window.dn = window.dn || {};

/** All methods related to vehicles */
(function (vehicle, $, undefined)
{
    // Generated by our GetMakesForJavaScript SQL view
    vehicle.MakesAll = 
    {
        'Abarth': [2],
        'AC': [2],
        'Acura': [2],
        'Advance Mixer': [8],
        'Alfa Romeo': [2],
        'Allard': [2],
        'Allstate': [2],
        'Alpine': [2],
        'Alvis': [2],
        'AM General': [2],
        'American Austin': [2],
        'American Bantam': [2],
        'American IronHorse': [7],
        'American LaFrance': [8],
        'American Motors': [2],
        'Amphicar': [2],
        'Apollo': [2],
        'Apperson': [2],
        'Aprilia': [7],
        'Arctic Cat': [7],
        'Argo': [7],
        'Armstrong-Siddeley': [2],
        'Arnolt-Bristol': [2],
        'Arnolt-MG': [2],
        'Aston Martin': [2],
        'Astra': [8],
        'Asuna': [2],
        'ATK': [7],
        'Auburn': [2],
        'Audi': [2,8],
        'Austin': [2],
        'Austin Healey': [2],
        'Autocar': [8],
        'Autocar LLC.': [8],
        'Avanti': [2],
        'BAIC': [2],
        'Bajaj': [7],
        'Benelli': [7],
        'Bentley': [2],
        'Bering': [8],
        'Berkeley': [2],
        'Bertone': [2],
        'Beta': [7],
        'Biddle': [2],
        'Big Bear Choppers': [7],
        'Big Dog': [7],
        'Bimota': [7],
        'Bizzarrini': [2],
        'Blackhawk': [2],
        'Blue Bird': [8],
        'BMW': [2,7],
        'Bobcat': [7],
        'Bombardier': [7],
        'Bond': [2],
        'Borgward': [2],
        'Bricklin': [2],
        'Bristol': [2],
        'Buell': [7],
        'Bugatti': [2],
        'Buick': [2],
        'Bultaco': [7],
        'Bus & Coach Intl (BCI)': [8],
        'Cadillac': [2],
        'Cagiva': [7],
        'Can-Am': [7],
        'Cannondale': [7],
        'Capacity Of Texas': [8],
        'Case': [2],
        'Case IH': [7],
        'Caterpillar': [8],
        'CFMOTO': [7],
        'Chance Coach Transit Bus': [8],
        'Chandler': [2],
        'Checker': [2],
        'Chevrolet': [2,8],
        'Chrysler': [2],
        'Cisitalia': [2],
        'Citroen': [2],
        'Cleveland': [2],
        'Cobra': [7],
        'Coda': [2],
        'Cole': [2],
        'Continental': [2],
        'Cord': [2],
        'Country Coach Motorhome': [8],
        'Crane Carrier': [8],
        'Crosley': [2],
        'Crown Coach': [8],
        'Cub Cadet': [7],
        'Cunningham': [2],
        'Daewoo': [2],
        'DAF': [2],
        'Daihatsu': [2],
        'Daimler': [2],
        'Darrin': [2],
        'Datsun': [2],
        'Davis': [2],
        'De Vaux': [2],
        'Delage': [2],
        'Delahaye': [2],
        'Dellow': [2],
        'DeLorean': [2],
        'Denzel': [2],
        'DeSoto': [2],
        'DeTomaso': [2],
        'Deutsch-Bonnet': [2],
        'Diamond Reo': [8],
        'Diana': [2],
        'Dina': [8],
        'Dina Transit Bus': [8],
        'DKW': [2],
        'Dodge': [2,8],
        'Doretti': [2],
        'Du Pont': [2],
        'Dual-Ghia': [2],
        'Ducati': [7],
        'Duesenberg': [2],
        'Duplex': [8],
        'Durant': [2],
        'Duryea': [2],
        'E-TON': [7],
        'Eagle': [2],
        'Eagle Transit Buses': [8],
        'Edsel': [2],
        'El Dorado': [8],
        'Elcar': [2],
        'Elva': [2],
        'Emergency One': [8],
        'Erik Buell Racing': [7],
        'Erskine': [2],
        'Essex': [2],
        'Evobus': [8],
        'Excalibur': [2],
        'Excelsior-Henderson': [7],
        'Facel Vega': [2],
        'Fairthorpe': [2],
        'Falcon Knight': [2],
        'Fargo': [2],
        'FAW': [2,8],
        'Federal Motors': [8],
        'Ferrara': [8],
        'Ferrari': [2],
        'Fiat': [2],
        'Fisker': [2],
        'Flint': [2],
        'Flxible Transit Bus': [8],
        'Ford': [2,8],
        'Foretravel Motorhome': [8],
        'Foton': [2,8],
        'Franklin': [2],
        'Frazer': [2],
        'Frazer Nash': [2],
        'Freightliner': [2,8],
        'FWD': [2],
        'FWD Corporation': [8],
        'Gardner': [2],
        'Gas Gas': [7],
        'GEM': [7],
        'Genesis': [2],
        'Genesis Transit Buses': [8],
        'Geo': [2],
        'Giant': [8],
        'Giant Motors': [2,8],
        'Gillig': [8],
        'Glas': [2],
        'GMC': [2,8],
        'Goggomobil': [2],
        'Goliath': [2],
        'Gordon-Keeble': [2],
        'Graham': [2],
        'Graham-Paige': [2],
        'Grande West': [8],
        'Griffith': [2],
        'Hansa': [2],
        'Harley Davidson': [7],
        'Haynes': [2],
        'HCS': [2],
        'Healey': [2],
        'Hendrickson': [8],
        'Henry J': [2],
        'Hertz': [2],
        'Hillman': [2],
        'Hino': [8],
        'Hispano-Suiza': [2],
        'HM': [7],
        'Honda': [2,7],
        'Hotchkiss': [2],
        'HRG': [2],
        'Hudson': [2],
        'Humber': [2],
        'Hummer': [2],
        'Hupmobile': [2],
        'Husaberg': [7],
        'Husqvarna': [7],
        'Hyosung': [7],
        'Hyundai': [2,8],
        'IC Corporation': [8],
        'Indian': [7],
        'Indiana Phoenix': [8],
        'Infiniti': [2],
        'International': [2,8],
        'Iso': [2],
        'Isotta Fraschini': [2],
        'Isuzu': [2,8],
        'Italika': [7],
        'Iveco': [8],
        'JAC': [2],
        'Jaguar': [2],
        'Jeep': [2],
        'Jeffery': [2],
        'Jensen': [2],
        'Jewett': [2],
        'John Deere': [7],
        'Jordan': [2],
        'Jowett': [2],
        'Kaiser': [2],
        'Kalmar': [8],
        'Karma': [2],
        'Kasea': [7],
        'Kawasaki': [7],
        'Kenworth': [8],
        'Kia': [2],
        'Kimble Chassis': [8],
        'Kissel': [2],
        'Kovatch': [8],
        'KTM': [7],
        'Kubota': [7],
        'Kurtis': [2],
        'KYMCO': [7],
        'Lada': [2],
        'Laforza': [2],
        'Lagonda': [2],
        'Lamborghini': [2],
        'Lanchester': [2],
        'Lancia': [2],
        'Land Rover': [2],
        'LaSalle': [2],
        'Lea-Francis': [2],
        'LEM': [7],
        'Les Autobus MCI': [8],
        'Lexington': [2],
        'Lexus': [2],
        'Lincoln': [2],
        'Lloyd': [2],
        'Locomobile': [2],
        'Lodal': [8],
        'Lotus': [2],
        'Mack': [8],
        'Mahindra': [7],
        'Maico': [2,7],
        'MAN': [8],
        'Marathon': [2],
        'Marauder': [2],
        'Marcos': [2],
        'Marmon': [2],
        'Marmon Herrington': [8],
        'Marquette': [2],
        'MASA': [8],
        'Maserati': [2],
        'Mastretta': [2],
        'Matra': [2],
        'Maxim': [8],
        'Maxwell': [2],
        'Maybach': [2],
        'Mazda': [2],
        'McLaren': [2],
        'Mercedes-Benz': [2,8],
        'Mercury': [2],
        'Merkur': [2],
        'Messerschmitt': [2],
        'Metropolitan': [2],
        'MG': [2],
        'Mini': [2],
        'Mitsubishi': [2],
        'Mitsubishi Fuso': [8],
        'Mobility Ventures': [2],
        'Monteverdi': [2],
        'Moon': [2],
        'Moretti': [2],
        'Morgan': [2],
        'Morris': [2],
        'Moskvich': [2],
        'Moto Guzzi': [7],
        'Moto-Ski': [7],
        'Motor Coach Industries': [8],
        'MV Agusta': [7],
        'Nardi': [2],
        'Nash': [2],
        'Neoplan': [8],
        'New Flyer': [8],
        'New Holland': [7],
        'Nissan': [2],
        'North American Bus Industries (NABI)': [8],
        'Nova Bus Corporation': [8],
        'NSU': [2],
        'Oakland': [2],
        'ODES': [7],
        'Oldsmobile': [2],
        'Omega': [2],
        'Ontario Bus': [8],
        'Opel': [2],
        'Orion Bus': [8],
        'Osca': [2],
        'Oshkosh Motor Truck Co.': [8],
        'Ottawa': [8],
        'Packard': [2],
        'Paige': [2],
        'Panhard': [2],
        'Panoz': [2],
        'Panther': [2],
        'Peerless': [2],
        'Pegaso': [2],
        'Peterbilt': [8],
        'Peugeot': [2],
        'Piaggio': [7],
        'Pierce Mfg. Inc.': [8],
        'Pierce-Arrow': [2],
        'Plymouth': [2],
        'Polaris': [7],
        'Polini': [7],
        'Pontiac': [2],
        'Porsche': [2],
        'Prevost': [8],
        'Proterra': [8],
        'Qvale': [2],
        'Ram': [2,8],
        'Rambler': [2],
        'Redcat Motors': [7],
        'Redline': [7],
        'Reliant': [2],
        'Renault': [2,7],
        'Reo': [2],
        'Rickenbacker': [2],
        'Riley': [2],
        'Roadmaster Rail': [8],
        'Roamer': [2],
        'Rockne': [2],
        'Rollin': [2],
        'Rolls-Royce': [2],
        'Roosevelt': [2],
        'Rover': [2],
        'Royal Enfield': [7],
        'Rupp': [7],
        'Saab': [2],
        'Sabra': [2],
        'Saleen': [2],
        'Salmson': [2],
        'Saturn': [2],
        'Savage': [8],
        'Scania': [8],
        'Scion': [2],
        'Scorpion': [7],
        'Scripps Booth': [2],
        'SDG': [7],
        'Sea-Doo': [7],
        'Seagrave Fire Apparatus': [8],
        'Seat': [2],
        'Shelby': [2],
        'Sheridan': [2],
        'Siata': [2],
        'Simca': [2],
        'Singer': [2],
        'Ski-Doo': [7],
        'Skoda': [2],
        'Smart': [2],
        'Sno-Jet': [7],
        'Spartan Motors': [8],
        'Spyker': [2],
        'SRT': [2],
        'SsangYong': [2],
        'Standard': [2],
        'Stanguellini': [2],
        'Star': [2],
        'Stearns Knight': [2],
        'Sterling': [2],
        'Sterling Truck': [8],
        'Stevens-Duryea': [2],
        'Stewart & Stevenson': [8],
        'Studebaker': [2],
        'Stutz': [2],
        'Subaru': [2],
        'Sunbeam': [2],
        'Sutphen Corp.': [8],
        'Suzuki': [2,7],
        'Swallow': [2],
        'Talbot-Lago': [2],
        'Tatra': [2],
        'Temsa Bus': [8],
        'Terex / Terex Advance': [8],
        'Tesla': [2],
        'Textron': [7],
        'TGB': [7],
        'Think': [2],
        'Thomas': [8],
        'TigerShark': [7],
        'TM': [7],
        'Toyopet': [2],
        'Toyota': [2],
        'Transportation Mfg Corp.': [8],
        'Triumph': [2,7],
        'Tucker': [2],
        'Turner': [2],
        'TVR': [2],
        'UAZ': [2],
        'UD': [8],
        'Unimog': [8],
        'Utilimaster': [2],
        'VAM': [2],
        'Van Hool': [8],
        'Vauxhall': [2],
        'Velie': [2],
        'Vento': [7],
        'Vespa': [2,7],
        'Victory': [7],
        'Viking': [2],
        'Volkswagen': [2,8],
        'Volvo': [2,8],
        'VOR': [7],
        'VPG': [2],
        'Wartburg': [2],
        'Westcott': [2],
        'Western RV': [8],
        'Western Star': [8],
        'Wet Jet': [7],
        'Whippet': [2],
        'White': [8],
        'White/GMC': [8],
        'Willys': [2],
        'Windsor': [2],
        'Wolseley': [2],
        'Workhorse': [2,8],
        'Workhorse Custom Chassis': [8],
        'Yamaha': [7],
        'Yellow Cab': [2],
        'Yugo': [2],
        'Zacua': [2],
        'Zeligson': [8],
        'ZERO': [7],
        'Zundapp': [2]
    };

    vehicle.MakesPopular = 
    [
        'Acura',
        'Audi',
        'BMW',
        'Buick',
        'Cadillac',
        'Chevrolet',
        'Chrysler',
        'Dodge',
        'Fiat',
        'Ford',
        'GMC',
        'Honda',
        'Hyundai',
        'Infiniti',
        'Jaguar',
        'Jeep',
        'Kia',
        'Land Rover',
        'Lexus',
        'Lincoln',
        'Mazda',
        'Mercedes-Benz',
        'Mitsubishi',
        'Nissan',
        'Plymouth',
        'Pontiac',
        'Porsche',
        'Ram',
        'Subaru',
        'Suzuki',
        'Toyota',
        'Volkswagen',
        'Volvo'
    ];

    vehicle.AllMakeLists = 
    [
        'All Asian', 
        'All European', 
        'All FCA', 
        'All Ford', 
        'All GM', 
        'All Heavy Duty',
        'All Powersports', 
        'All Stellantis'
    ];

    /** Some makes split out to multiple makes, e.g. Honda -> Honda/Acura */
    vehicle.MakeLists = 
    {
        'All Asian': 'Acura,Daewoo,Daihatsu,Honda,Hyundai,Infiniti,Isuzu,Kia,Lexus,Mazda,Mitsubishi,Nissan,Scion,Subaru,Suzuki,Toyota',
        'All European': 'Aston Martin,Audi,Bentley,BMW,Ferrari,Jaguar,Lamborghini,Land Rover,Mercedes-Benz,Mini,Porsche,Rolls Royce,Saab,VW',
        // See "All Stellantis" below, they now own FCA.
        'All FCA': 'Chrysler,Dodge,Fiat,Jeep,Plymouth,Ram',
        'All Ford': 'Ford,Lincoln,Mercury',
        'All GM': 'Buick,Cadillac,Chevrolet,GMC,Hummer,Oldsmobile,Pontiac,Saturn',
        // Stellantis is owner of FCA, thus this includes all vehicles covered in "All FCA"
        'All Stellantis': 'Abarth,Alfa Romeo,Chrysler,Citroen,Dodge,Fiat,Jeep,Lancia,Maserati,Opel,Peugeot,Plymouth,Ram,Vauxhall',
        'Honda': 'Acura,Honda',
        'Hyundai': 'Genesis,Hyundai,Kia',
        'Land Rover': 'Land Rover,Range Rover',
        'Nissan': 'Datsun,Infiniti,Nissan',
        'Toyota': 'Lexus,Scion,Toyota'
    };

    /**
     * Takes a vehicle model year, potentially 2-digits in length, and returns a 4-digit
     * model year. If the year is not 2-digits, it is returned as-is. The logic is based
     * on looking at the current year (or given yearContext), and choosing something that 
     * makes sense based on that year and surrounding centuries, so it should work indefinitely
     * because all it's doing is making a best-effort guess at what you mean in the current year.
     * 
     * E.g. If the current year is 2020 and the person writes "22" then we'll assume 2022.
     * If they write 24, then we'll assume 1924, since there shouldn't even be a model year
     * of 2024 available in year 2022 (at least under our current logic). 
     * 
     * It's dynamic enough so that even if this code is running a hundred years from now,
     * say in 2120, we'll do something that makes sense: the user writes "22" and we'll 
     * assume it's a 2122 model year. If they write "24", we'll assume it's a 2024 model.
     * 
     * NOTE: Keep logic in sync with `DN.Vehicles.Vehicle.FixModelYear()`.
     * 
     * @param {int}     modelYear - The model year, potentially 2-digits in length.
     * @param {int?}    yearContext - If non-null, we'll treat this year as the current year, for purposes of model year parsing.
     */
    vehicle.FixModelYear = function(modelYear, yearContext)
    {
        var currentYear = yearContext || dn.constants.CurrentYear;
        var currentCentury = Math.floor(currentYear / 100) * 100;
        var maxModelYearTwoDigits = currentYear - currentCentury + 2;

        if (modelYear <= maxModelYearTwoDigits)
        {
            // E.g. If current year we're living in is 2021, this checks to see if the 
            // year given in text is <= 23, and if so, we'll add 2000 to it. 
            return (modelYear + currentCentury);
        }
        else if (modelYear < 100)
        {
            // Year ranges from 24–99 (assuming current year is 2021, the prior IF
            // clause covers 00-23).
            return (modelYear + currentCentury - 100);
        }

        return modelYear;
    };

    /**
     * Update the given dropdown to set the make dropdown choices.
     * 
     * @param {element} element - The element to set the makes in.
     * @param {boolean} onlyPopular - Only show popular makes.
     * @param {boolean} onlyTypeGroup - Only show makes with the given type group, e.g. 2 = light duty, 7 = powersport, 8 = heavy duty
     */
    vehicle.SetMakeChoices = function(element, onlyPopular, onlyTypeGroup)
    {
        console.debug("vehicle.SetMakeChoices", onlyPopular, onlyTypeGroup);

        var newHtml = ['<button class="dropdown-item dropdown-selected" data-make=""><i class="fal fa-check fa-fw"></i>All Makes</button>'];

        $.each(vehicle.AllMakeLists, function( index, value ) 
        {
            newHtml.push('<button class="dropdown-item" data-make="' + value + '"><i class="fal fa-check fa-fw"></i>' + value + '</button>')
        });

        newHtml.push('<div class="dropdown-divider"></div>');

        if (onlyPopular)
        {
            $.each
            (
                vehicle.MakesPopular, 
                function(index, value)
                {
                    newHtml.push('<button class="dropdown-item" data-make="' + value + '"><i class="fal fa-check fa-fw"></i>' + value + '</button>');
                }
            );

            newHtml.push('<div class="dropdown-divider"></div>');
            newHtml.push('<button class="dropdown-item" onclick="return false" data-make="-2"><i class="fal fa-check fa-fw"></i>Show Light Duty</button>');
            newHtml.push('<button class="dropdown-item" onclick="return false" data-make="-8"><i class="fal fa-check fa-fw"></i>Show Heavy Duty</button>');
            newHtml.push('<button class="dropdown-item" onclick="return false" data-make="-7"><i class="fal fa-check fa-fw"></i>Show Powersports</button>');
            newHtml.push('<div class="dropdown-divider"></div>');
            newHtml.push('<button class="dropdown-item" onclick="return false" data-make="-all"><i class="fal fa-check fa-fw"></i>Show More</button>');
        }
        else
        {
            if (onlyTypeGroup > 0)
            {
                // Only light duty, heavy duty, or powersports
                $.each
                (
                    $.map
                    (
                        vehicle.MakesAll, 
                        function(prop,key) 
                        {
                            return ($.inArray(onlyTypeGroup, prop) > -1) ? key : null;
                        }
                    ), 
                    function(index, value)
                    {
                        newHtml.push('<button class="dropdown-item" data-make="' + value + '"><i class="fal fa-check fa-fw"></i>' + value + '</button>');
                    }
                );
            }
            else
            {
                // ALL MAKES!
                $.each
                (
                    Object.keys(vehicle.MakesAll), 
                    function(index, value)
                    {
                        newHtml.push('<button class="dropdown-item" data-make="' + value + '"><i class="fal fa-check fa-fw"></i>' + value + '</button>');
                    }
                );
            }

            newHtml.push('<div class="dropdown-divider"></div>');
            newHtml.push('<button class="dropdown-item" onclick="return false" data-make="-2"><i class="fal fa-check fa-fw"></i>Show Light Duty</button>');
            newHtml.push('<button class="dropdown-item" onclick="return false" data-make="-8"><i class="fal fa-check fa-fw"></i>Show Heavy Duty</button>');
            newHtml.push('<button class="dropdown-item" onclick="return false" data-make="-7"><i class="fal fa-check fa-fw"></i>Show Powersports</button>');
            newHtml.push('<div class="dropdown-divider"></div>');
            newHtml.push('<button class="dropdown-item" onclick="return false" data-make="-popular"><i class="fal fa-check fa-fw"></i>Show Popular</button>');
        }

        $(element).html(newHtml.join(""));
    }

}(window.dn.vehicle = window.dn.vehicle || {}, jQuery));
